export default "__VITE_ASSET__DLT_3umF__"